import React, { useEffect, useState } from "react";
import { Typography, Card, Box, Modal, Button, Avatar } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import IconButton from "@mui/material/IconButton";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  getEngagementTemplate,
  templateVisitHistoryUpdate,
} from "./Network_Call";
import CloseIcon from "@mui/icons-material/Close";

function CustomerEngagementTemplate(props) {
  const [savedTemplates, setSavedTemplates] = useState([]);
  const [copiedStatus, setCopiedStatus] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  useEffect(() => {
    const getEngagementTemplates = async () => {
      const result = await getEngagementTemplate(
        props.implId,
        props.external_id
      );
      if (result.status === 200) {
        setSavedTemplates(result.data.data);
      } else {
        console.error("Error fetching templates.");
      }
    };
    getEngagementTemplates();
  }, [props.implId]);

  const handleCopy = async (templateId, htmlContent) => {
    try {
      await navigator.clipboard.write([
        new ClipboardItem({
          "text/html": new Blob([htmlContent], { type: "text/html" }),
        }),
      ]);

      setCopiedStatus((prevStatus) => ({
        ...prevStatus,
        [templateId]: true,
      }));

      setTimeout(() => {
        setCopiedStatus((prevStatus) => ({
          ...prevStatus,
          [templateId]: false,
        }));
      }, 2000);

      handleTemplateClick(templateId, props.external_id);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

  const openTemplateModal = (template) => {
    setSelectedTemplate(template);
    setOpenModal(true);
  };

  const closeModal = () => {
    setOpenModal(false);
    setSelectedTemplate(null);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: "numeric", month: "short", year: "numeric" };
    const formattedDate = date.toLocaleDateString("en-GB", options);

    const now = new Date();
    const seconds = Math.floor((now - date) / 1000);

    let timeAgo;
    if (seconds < 60) {
      timeAgo = `${seconds} second${seconds === 1 ? "" : "s"} ago`;
    } else if (seconds < 3600) {
      const minutes = Math.floor(seconds / 60);
      timeAgo = `${minutes} minute${minutes === 1 ? "" : "s"} ago`;
    } else if (seconds < 86400) {
      const hours = Math.floor(seconds / 3600);
      timeAgo = `${hours} hour${hours === 1 ? "" : "s"} ago`;
    } else if (seconds < 2592000) {
      const days = Math.floor(seconds / 86400);
      timeAgo = `${days} day${days === 1 ? "" : "s"} ago`;
    } else if (seconds < 31536000) {
      const months = Math.floor(seconds / 2592000);
      timeAgo = `${months} month${months === 1 ? "" : "s"} ago`;
    } else {
      const years = Math.floor(seconds / 31536000);
      timeAgo = `${years} year${years === 1 ? "" : "s"} ago`;
    }
    return `${timeAgo}`;
  };

  const handleTemplateClick = async (templateId, external_id) => {
    console.log("templateID", templateId);
    try {
      const response = await templateVisitHistoryUpdate(
        templateId,
        external_id
      );
      console.log("templateID", response);

      if (response.status === 200) {
        // Increment the views count locally
        setSavedTemplates((prevTemplates) =>
          prevTemplates.map((template) =>
            template.id === templateId
              ? { ...template, view_count: (template.view_count || 0) + 1 }
              : template
          )
        );
      }
    } catch (error) {
      console.error("Error updating template views: ", error);
      toast.error("Failed to update template views.");
    }
  };

  console.log("template", savedTemplates);

  return (
    <>
      <ToastContainer />
      <div style={{ margin: "1rem" }}>
        <Typography
          variant="h5"
          sx={{ fontWeight: "bold", marginBottom: "20px" }}
        >
          <span style={{ color: "#FF5900" }}>Engagement</span>{" "}
          <span style={{ color: "#00A0B2" }}>Templates</span>
        </Typography>

        {savedTemplates.length > 0 ? (
          <div>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
              {savedTemplates.map((template) => (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    flexBasis: "100%",
                    maxWidth: "30%",
                  }}
                >
                  <Card
                    key={template.id}
                    sx={{
                      padding: "20px",
                      boxShadow: "0 5px 10px rgba(0, 0, 0, 0.15)",
                      borderRadius: "12px",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      border: "1px solid #00A0B2",
                      "&:hover": {
                        transform: "translateY(-5px)",
                        boxShadow: "0 6px 12px rgba(0, 0, 0, 0.2)",
                      },
                      width: "100%",
                    }}
                  >
                    <Typography variant="h6" sx={{ marginBottom: "10px" }}>
                      {template.template_name}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ marginBottom: "15px" }}
                    >
                      {template.description}
                    </Typography>
                    <Button
                      onClick={() => openTemplateModal(template)}
                      style={{
                        backgroundColor: "#00A0B2",
                        borderRadius: "0.3rem",
                        color: "#fff",
                        fontWeight: "bold",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                      }}
                    >
                      View Template
                    </Button>
                  </Card>
                  <Box
                    sx={{
                      textAlign: "right",
                      marginTop: "10px",
                      display: "flex",
                      justifyContent: "space-between",
                      margin: "0.5rem",
                    }}
                  >
                    <Typography variant="caption" color="textSecondary">
                      Uses{" "}
                      <span style={{ fontWeight: "bolder" }}>
                        {template.view_count} times
                      </span>
                    </Typography>

                    <Typography variant="caption" color="textSecondary">
                      Updated{" "}
                      <span style={{ fontWeight: "bolder" }}>
                        {formatDate(template.last_updated_at)}
                      </span>
                    </Typography>
                  </Box>
                </div>
              ))}
            </Box>

            <Modal open={openModal} onClose={closeModal}>
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  Width: { xs: "90%", sm: "70%", md: "50%" },
                  bgcolor: "background.paper",
                  boxShadow: 24,
                  p: 4,
                  borderRadius: "10px",
                  maxHeight:"50rem"
                }}
              >
                {selectedTemplate && (
                  <>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: "1rem",
                      }}
                    >
                      <Typography variant="h5">
                        {selectedTemplate.template_name}
                      </Typography>
                      <IconButton onClick={closeModal}>
                        <CloseIcon />
                      </IconButton>
                    </Box>
                    <Box
                      sx={{
                        backgroundColor: "#f5f5f5",
                        padding: "10px",
                        borderRadius: "10px",
                        marginBottom: "20px",
                        maxHeight: "40rem",
                        overflowY:"scroll"
                      }}
                      dangerouslySetInnerHTML={{
                        __html: selectedTemplate.template,
                      }}
                    />
                    <div style={{ textAlign: "right" }}>
                      <Button
                        onClick={() =>
                          handleCopy(
                            selectedTemplate.id,
                            selectedTemplate.template
                          )
                        }
                        startIcon={
                          copiedStatus[selectedTemplate.id] ? (
                            <CheckIcon />
                          ) : (
                            <ContentCopyIcon />
                          )
                        }
                      >
                        {copiedStatus[selectedTemplate.id] ? "Copied" : "Copy"}
                      </Button>
                    </div>
                  </>
                )}
              </Box>
            </Modal>
          </div>
        ) : (
          <>No Templates Found</>
        )}
      </div>
    </>
  );
}

export default CustomerEngagementTemplate;
